import { render, staticRenderFns } from "./AskChatGPT.vue?vue&type=template&id=68eda2d8&scoped=true"
import script from "./AskChatGPT.vue?vue&type=script&lang=js"
export * from "./AskChatGPT.vue?vue&type=script&lang=js"
import style0 from "./AskChatGPT.vue?vue&type=style&index=0&id=68eda2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eda2d8",
  null
  
)

export default component.exports